export enum LoanMerchantName {
  TBI = 'tbi'
}

export interface LoanInfoResult {
  total: number
  installment: number
  interestPercentage: string
  loanFee: number
}

export interface LoanTargetResult {
  targetUrl: string
}
